import { useSelector } from 'react-redux';
import { placeholders } from './selectors';

// always return an object
export const usePlaceholders = () => useSelector(placeholders);
